import React, { useState, useRef, useEffect } from "react";
import styles from "./Navbar.module.css";
import { Link } from "react-router-dom";
import logo from '../Assets/logo.jpeg'; // Corrected the image file extension

export default function Navbar() {
    const [isProductOpen, setIsProductOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const productDropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (productDropdownRef.current && !productDropdownRef.current.contains(e.target)) {
                setIsProductOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Handle navbar background on scroll
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const closeMobileMenu = () => setIsMobileMenuOpen(false);

    return (
        <nav className={`${styles.navbar} ${isScrolled ? styles.scrolled : ''}`}>
            <Link to="/" className={styles.logoLink}>
                {/* Use the imported logo */}
                <img src={logo} alt="Cirkitex Logo" className={styles.logo} />
            </Link>

            <button
                className={styles.mobileToggle}
                onClick={() => setIsMobileMenuOpen(prev => !prev)}
                aria-label="Toggle menu"
            >
                {/* Animated hamburger icon */}
                <div className={`${styles.hamburger} ${isMobileMenuOpen ? styles.isOpen : ''}`}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </button>

            <ul className={`${styles.menu} ${isMobileMenuOpen ? styles.showMenu : ""}`}>
                <li><Link className={styles.link} to="/" onClick={closeMobileMenu}>Home</Link></li>
                <li><Link className={styles.link} to="/about" onClick={closeMobileMenu}>About</Link></li>

                <li
                    className={styles.dropdown}
                    ref={productDropdownRef}
                >
                    <button
                        className={styles.dropdownToggle}
                        onClick={() => setIsProductOpen(prev => !prev)}
                    >
                        Products <span className={styles.arrow}>▼</span>
                    </button>

                    <ul className={`${styles.dropdownMenu} ${isProductOpen ? styles.show : ""}`}>
                        <li className={styles.subDropdown}>
                            <Link to="/products/edge-ai-processor" className={styles.link} onClick={closeMobileMenu}>
                                Edge AI Processor <span className={styles.arrow}>▶</span>
                            </Link>
                            <ul className={styles.subDropdownMenu}>
                                <li><Link to="/products/edge-ai-processor/ctx" className={styles.link} onClick={closeMobileMenu}>CTX Edge AI Processor</Link></li>
                            </ul>
                        </li>
                        <li className={styles.subDropdown}>
                            <Link to="/products/analog-mixed-signal-ips" className={styles.link} onClick={closeMobileMenu}>
                                Analog Mixed Signal IPs <span className={styles.arrow}>▶</span>
                            </Link>
                            <ul className={styles.subDropdownMenu}>
                                <li><Link to="/products/analog-mixed-signal-ips/pll" className={styles.link} onClick={closeMobileMenu}>Phase Locked Loop (PLL)</Link></li>
                                <li><Link to="/products/analog-mixed-signal-ips/adc" className={styles.link} onClick={closeMobileMenu}>Analog-to-Digital Converter (ADC)</Link></li>
                            </ul>
                        </li>
                    </ul>
                </li>

                <li><Link className={styles.link} to="/technology" onClick={closeMobileMenu}>Technology</Link></li>
                <li><Link className={styles.link} to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
            </ul>
        </nav>
    );
}

